import { Icon } from 'common/components/Icon';

import React from 'react';
import isNil from 'lodash/isNil';
import propTypes from 'prop-types';

export const CartIcon = ({ totalItems }) => (
  <div className="CartTrigger__inner">
    <Icon className="CartTrigger__icon cart-icon" name="cart-baseline" />
    <Icon className="CartTrigger__icon close-icon" name="close" />

    <div className="CartTrigger__quantity">
      {!isNil(totalItems) && totalItems !== 0 && totalItems}
    </div>
  </div>
);

CartIcon.propTypes = {
  totalItems: propTypes.number,
};
